import { useState } from 'preact/compat';
import {
  cancellationReasons,
  otpPageCancellationReasons,
} from '../../../../../constants';
import TextField from 'preact-material-components/TextField';
import 'preact-material-components/TextField/style.css';
import style from './style.css';

const CancellationReasonList = ({ setCancellationReason, pageKey }) => {
  const [options, setOptions] = useState(
    pageKey === 'pv_aivf_page_aivf'
      ? JSON.parse(JSON.stringify(otpPageCancellationReasons))
      : JSON.parse(JSON.stringify(cancellationReasons)),
  );
  const [isCustomReasonOpen, setIsCustomReasonOpen] = useState(false);

  const onChange = (selectedIndex) => {
    setCancellationReason('');
    if (selectedIndex === options.length - 1) {
      setIsCustomReasonOpen(true);
    } else {
      setIsCustomReasonOpen(false);
    }
    const updatedOptions = options.map((option, index) => {
      if (index === selectedIndex) {
        option.checked = true;
        index !== options.length - 1 && setCancellationReason(option.reason);
      } else {
        option.checked = false;
      }
      return option;
    });
    setOptions(updatedOptions);
  };

  const captureCustomReason = (e) => {
    setCancellationReason(`other:${e.target.value}`);
  };

  return (
    <div>
      <div
        className={`${
          style.listSubHeading
        } bold-text text-center font16 text80`}>
        Tell us why you want to cancel
      </div>
      {options.map((option, i) => {
        return (
          <div key={option.labelText}>
            <div className={style.radioContainer}>
              <input
                type='radio'
                id={`radio-${i}`}
                checked='checked'
                name='Controlled Options'
                checked={option.checked}
                onChange={() => onChange(i)}
              />
              <label className={style.labelText} for={`radio-${i}`}>
                {option.reason}
              </label>
            </div>
          </div>
        );
      })}
      <div className={style.textAreaContainer}>
        {isCustomReasonOpen && (
          <TextField
            maxlength='5000'
            textarea={true}
            label={'Enter your reason here'}
            onChange={captureCustomReason}
          />
        )}
      </div>
    </div>
  );
};

export default CancellationReasonList;



// WEBPACK FOOTER //
// ./components/partial/layers/modals/cancelTransactionModal/cancellationReasonList.js